export const SET_DOMAIN_NICKNAME = 'Atribua um apelido à este domínio'
